import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extractAWCDataFromEvent } from '@atlassian/analytics-bridge';
import { ActionSubject } from '@atlassian/proforma-utils/analytics';
import { NoticeType } from '../../components/Notice/noticeTypes';
import { constructApiError } from '../../models/ApiError';
export var AcceptedResponseType = /*#__PURE__*/function (AcceptedResponseType) {
  AcceptedResponseType["Json"] = "json";
  AcceptedResponseType["Blob"] = "blob";
  return AcceptedResponseType;
}({});
export var ApiUtil = /*#__PURE__*/function () {
  function ApiUtil(jiraUrl, proformaUrl, errorUtils, createAnalyticsEvent) {
    _classCallCheck(this, ApiUtil);
    this.errorUtils = void 0;
    this.jiraUrl = void 0;
    this.proformaUrl = void 0;
    this.createAnalyticsEvent = void 0;
    this.jiraUrl = jiraUrl;
    this.proformaUrl = proformaUrl;
    this.errorUtils = errorUtils;
    this.createAnalyticsEvent = createAnalyticsEvent;
  }
  return _createClass(ApiUtil, [{
    key: "get",
    value: function get(path, requestName) {
      var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AcceptedResponseType.Json;
      return this.fetchApi(true, 'GET', path, responseType, requestName);
    }
  }, {
    key: "jiraGet",
    value: function jiraGet(path, requestName) {
      var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AcceptedResponseType.Json;
      return this.fetchApi(false, 'GET', path, responseType, requestName);
    }
  }, {
    key: "put",
    value: function put(path, body, requestName) {
      var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AcceptedResponseType.Json;
      return this.fetchApi(true, 'PUT', path, responseType, requestName, body);
    }
  }, {
    key: "jiraPut",
    value: function jiraPut(path, body, requestName) {
      var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AcceptedResponseType.Json;
      return this.fetchApi(false, 'PUT', path, responseType, requestName, body);
    }
  }, {
    key: "post",
    value: function post(path, body, requestName) {
      var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AcceptedResponseType.Json;
      return this.fetchApi(true, 'POST', path, responseType, requestName, body);
    }
  }, {
    key: "jiraPost",
    value: function jiraPost(path, body, requestName) {
      var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AcceptedResponseType.Json;
      return this.fetchApi(false, 'POST', path, responseType, requestName, body);
    }
  }, {
    key: "delete",
    value: function _delete(path, body, requestName) {
      var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'none';
      return this.fetchApi(true, 'DELETE', path, responseType, requestName, body);
    }

    /** Converts the `relativePath` into an absolute ProForma API URI. */
  }, {
    key: "createApiUrl",
    value: function createApiUrl(relativePath) {
      return this.proformaUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }

    /** Converts the `relativePath` into an absolute Jira URI. */
  }, {
    key: "createJiraUrl",
    value: function createJiraUrl(relativePath) {
      return this.jiraUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
  }, {
    key: "getAnalyticsSource",
    value: function getAnalyticsSource() {
      try {
        var _analyticsData$payloa, _analyticsData$payloa2;
        var analyticsEvent = this.createAnalyticsEvent({});
        var analyticsData = extractAWCDataFromEvent(analyticsEvent);
        return (_analyticsData$payloa = analyticsData === null || analyticsData === void 0 || (_analyticsData$payloa2 = analyticsData.payload) === null || _analyticsData$payloa2 === void 0 ? void 0 : _analyticsData$payloa2.source) !== null && _analyticsData$payloa !== void 0 ? _analyticsData$payloa : 'unknown';
      } catch (e) {
        return 'unknown';
      }
    }
  }, {
    key: "fetchApi",
    value: function fetchApi(proForma, method, path, responseType, requestName, body) {
      var _this = this;
      var analyticsSource = this.getAnalyticsSource();
      return fetch(proForma ? this.createApiUrl(path) : this.createJiraUrl(path), _objectSpread({
        method: method,
        credentials: 'same-origin',
        headers: _objectSpread({
          'Content-Type': 'application/json',
          'X-Experimental-Experience': analyticsSource
        }, responseType === AcceptedResponseType.Json ? {
          Accept: 'application/json'
        } : {})
      }, body && {
        body: JSON.stringify(body)
      })).catch(function (error) {
        var message = "No response from API: ".concat(error.message || '');
        var apiError = toApiError(0, {
          error: message
        }, true, requestName);
        _this.errorUtils.reportError(error, {
          actionSubject: ActionSubject.PROFORMA_API,
          id: 'fetchApi',
          attributes: {
            path: path,
            method: method,
            responseType: responseType,
            requestName: requestName,
            apiError: JSON.stringify(apiError),
            isClientFetchError: true
          }
        });
        return Promise.reject(apiError);
      }).then(function (response) {
        var errorObj = new Error(response.statusText);
        if (!response.ok) {
          var _ref, _response$headers$get;
          var traceId = (_ref = (_response$headers$get = response.headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response.headers.get('atl-traceid')) !== null && _ref !== void 0 ? _ref : undefined;
          var apiErrorPromise;
          try {
            // Try to parse response error details
            var responseJsonApiError = responseType !== 'json' ? undefined : response.json().then(function (responseJson) {
              return toApiError(response.status, responseJson, false, requestName, traceId);
            }).catch(function (error) {
              var message = "Failed to parse error response as JSON from API: ".concat(error.message || '');
              errorObj = error;
              return toApiError(response.status, {
                error: message
              }, false, requestName, traceId);
            });
            if (response.status === 401) {
              _this.errorUtils.notifyUser(NoticeType.ErrorApiUnauthorised);
            }
            if (response.status === 403) {
              _this.errorUtils.notifyUser(NoticeType.ErrorApiMissingPermissions);
            }
            if (responseJsonApiError !== undefined) {
              apiErrorPromise = responseJsonApiError.then(function (apiError) {
                return Promise.reject(apiError);
              });
            } else {
              // Create error object with error response body
              apiErrorPromise = Promise.reject(toApiError(response.status, {
                error: response.body || ''
              }, false, requestName, traceId));
            }
          } catch (error) {
            var message = "Unexpected response from API: ".concat(response.body || '');
            errorObj = error;
            apiErrorPromise = Promise.reject(toApiError(response.status, {
              error: message
            }, false, requestName, traceId));
          }
          apiErrorPromise.catch(function (apiError) {
            _this.errorUtils.reportError(errorObj, {
              actionSubject: ActionSubject.PROFORMA_API,
              id: 'fetchApi',
              attributes: {
                status: response.status,
                statusGroup: "".concat(Math.floor(response.status / 100), "xx"),
                traceId: traceId,
                path: path,
                method: method,
                responseType: responseType,
                requestName: requestName,
                apiError: JSON.stringify(apiError),
                isClientFetchError: false
              }
            });
          });
          return apiErrorPromise;
        }
        if (response.status === 204) {
          return '';
        }
        switch (responseType) {
          case 'json':
            return response.json();
          case 'blob':
            return response.blob();
          case 'text':
            return response.text();
          case 'none':
            return '';
          default:
            return response;
        }
      });
    }
  }]);
}();
function toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
  if (Object.keys(responseJson).length === 0) {
    return constructApiError("Unexpected API reply (HTTP/".concat(status, ")"), status, responseJson, requestName);
  }
  var error = responseJson['error'] || "Unexpected API reply (HTTP/".concat(status, ")");
  var context = responseJson['context'];
  var contextId = responseJson['contextId'];
  var details = responseJson['details'];
  return constructApiError(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
}